import { render, staticRenderFns } from "./DashboardGraphics.vue?vue&type=template&id=b0abc71a"
import script from "./DashboardGraphics.vue?vue&type=script&lang=js"
export * from "./DashboardGraphics.vue?vue&type=script&lang=js"
import style0 from "./DashboardGraphics.vue?vue&type=style&index=0&id=b0abc71a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports